import { Link, useLocation } from "react-router-dom";
import TrustComplianceBlock from "@/components/TrustComplianceBlock";

const Footer = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <footer className="bg-[#2D3748] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand & Contact */}
          <div className="md:col-span-2">
            <h3 className="font-playfair text-xl font-bold text-white mb-3">
              MyGLP1Compare.com
            </h3>
            <p className="text-gray-400 text-sm mb-2">
              Operated by Veritas Partners LLC (DBA MyGLP1Compare.com)
            </p>
            <p className="text-gray-400 text-sm mb-1">Nixa, MO</p>
            <p className="text-gray-400 text-sm mb-1">
              <a href="tel:417-318-7997" className="hover:text-white transition-colors">
                417-318-7997
              </a>
            </p>
            <p className="text-gray-400 text-sm">
              <a href="mailto:support@myglp1compare.com" className="hover:text-white transition-colors">
                support@myglp1compare.com
              </a>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-base mb-3">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/affiliates" className="text-gray-300 hover:text-white transition-colors">
                  Affiliates
                </Link>
              </li>
              <li>
                <Link to="/plan" className="text-gray-300 hover:text-white transition-colors">
                  Build Your Plan
                </Link>
              </li>
              <li>
                <Link to="/providers" className="text-gray-300 hover:text-white transition-colors">
                  Providers
                </Link>
              </li>

              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  About
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-semibold text-base mb-3">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/refund-policy" className="text-gray-300 hover:text-white transition-colors">
                  Refund & Cancellation
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-300 hover:text-white transition-colors">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-300 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer Section */}
        <div className="border-t border-gray-600 pt-6" data-testid="footer-disclaimer">
          <div className="bg-[#1A202C] rounded-lg p-5">
            <h5 className="font-semibold text-[#E07A5F] text-sm mb-2">Medical Disclaimer</h5>
            <p className="text-xs text-gray-400 mb-3">
              MyGLP1Compare.com does not provide medical advice, diagnosis, or treatment. 
              All medical evaluations, prescribing decisions, and clinical determinations are 
              made independently by licensed healthcare providers. Approval for treatment is not guaranteed.
            </p>
            <p className="text-xs text-gray-400">
              By using MyGLP1Compare to connect with Dosevana, you acknowledge 
              that medical eligibility is determined solely by the independent licensed provider.
            </p>
          </div>
        </div>

        {/* Trust & PCI Seal */}
        {!isAdminRoute && (
          <div className="border-t border-gray-600 pt-6 mt-8" data-testid="footer-pci-trust">
            <TrustComplianceBlock
              useLiveSeal={false}
              title="Secure payment notice"
              containerClassName="bg-[#1A202C] border border-[#2D3748] text-white"
              messageClassName="text-gray-400"
            />
          </div>
        )}

        {/* Bottom Bar */}
        <div className="mt-6 pt-4 border-t border-gray-600 text-center text-xs text-gray-400">
          <p className="mb-2">
            © {new Date().getFullYear()} MyGLP1Compare.com. All rights reserved.
          </p>
          <p>
            <Link to="/refund-policy" className="hover:text-white transition-colors">Refund Policy</Link>
            {" | "}
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Use</Link>
            {" | "}
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
